// extracted by mini-css-extract-plugin
export default {"popupTitle":"search-dropdown_popupTitle__Ao0kF","popupContent":"search-dropdown_popupContent__viXVp","mainTextboxInactive":"search-dropdown_mainTextboxInactive__tt-ln"};